import Select from "react-select";

export default function SelectPadrao({
    options = [],
    name,
    placeholder = "Selecione",
    value,
    onChange,
    getOptionLabel,
    getOptionValue,
    isClearable = true,
    isDisabled = false,
    customOptionLabel
}) {

    const defaultFormat = ({ label, ativo }) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {ativo !== undefined && (
                <div
                    style={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: ativo ? '#28a745' : '#dc3545',
                        flexShrink: 0
                    }}
                />
            )}
            <span>{label}</span>
        </div>
    );

    return (
        <Select
            options={options}
            placeholder={placeholder}
            isClearable={isClearable}
            isDisabled={isDisabled}
            value={options.find(opt => opt.value === value) || null}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            formatOptionLabel={customOptionLabel || defaultFormat}
            onChange={(selected) => {
                onChange({
                    target: {
                        name,
                        value: selected?.value || 0
                    }
                });
            }}
        />
    );
}